export const LO_COMPANY_BREADCRUMBS = [
    { text: 'Admin', key: 'Admin' },
    { text: 'LO Company', key: 'LoCopmany' }
];